import React, { useState, useEffect } from 'react';
import AdminLayout from './AdminLayout';
import CategoryCard from './components/CategoryCard';
import { getAdminCategories } from '../config/api';

export default function PhotoGallery() {
  const [categories, setCategories] = useState([]);
  const [categoryCounts, setCategoryCounts] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadCategories();
  }, []);

  const loadCategories = async () => {
    setLoading(true);
    setError(null);

    try {
      // Fetch all categories (includes photo_count from backend)
      const categoriesRes = await getAdminCategories();
      const cats = categoriesRes.data?.data || [];
      setCategories(cats);

      // Extract photo counts from category data (no additional API calls needed)
      const counts = {};
      let totalCount = 0;

      cats.forEach(cat => {
        const count = parseInt(cat.photo_count, 10) || 0;
        counts[cat.id] = count;
        totalCount += count;
      });

      counts['all'] = totalCount;
      setCategoryCounts(counts);

    } catch (err) {
      console.error('Failed to load categories:', err);
      setError('Unable to load categories. Please refresh the page.');
    } finally {
      setLoading(false);
    }
  };

  const mobileStyle = `
    @media (max-width: 768px) {
      .photo-gallery-grid {
        grid-template-columns: 1fr !important;
      }
    }
  `;

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
    gap: 16,
    marginTop: 24,
  };

  if (loading) {
    return (
      <AdminLayout title="Photo Gallery">
        <div style={{
          fontFamily: 'var(--font-body)',
          fontSize: 13,
          color: 'var(--color-muted)'
        }}>
          Loading categories...
        </div>
      </AdminLayout>
    );
  }

  if (error) {
    return (
      <AdminLayout title="Photo Gallery">
        <div style={{
          fontFamily: 'var(--font-body)',
          fontSize: 13,
          color: 'var(--color-error)',
          marginBottom: 16,
        }}>
          {error}
        </div>
        <button
          onClick={loadCategories}
          style={{
            padding: '10px 20px',
            background: 'var(--color-accent)',
            color: '#fff',
            border: 'none',
            borderRadius: 4,
            fontSize: 13,
            fontFamily: 'var(--font-body)',
            cursor: 'pointer',
          }}
        >
          Retry
        </button>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout title="Photo Gallery">
      <style>{mobileStyle}</style>
      <div style={gridStyle} className="photo-gallery-grid">
        {/* All Categories card first */}
        <CategoryCard
          isAllCategories={true}
          photoCount={categoryCounts['all'] || 0}
        />

        {/* Individual category cards */}
        {categories.map(cat => (
          <CategoryCard
            key={cat.id}
            category={cat}
            photoCount={categoryCounts[cat.id] || 0}
          />
        ))}
      </div>
    </AdminLayout>
  );
}
